import { CharacterReshuffleResponse } from '../../types/character';

export const reshuffleCharacterModel = (response: CharacterReshuffleResponse): CharacterReshuffleResponse => response;
